<svg id="slash" fill="none" stroke="currentColor" viewBox="0 0 16 16">
  <path d="M10 3L6 13" stroke-width="1" stroke-linecap="round"/>
</svg>
